import EventSlider from "./components/event_slider";
import Leaflet from "leaflet";
import "leaflet/dist/leaflet.css";
import "./components/leaflet/fullscreen/Control.FullScreen"
import "./components/leaflet/fullscreen/Control.FullScreen.css"

EventSlider.initiates();
let map;

initiatesMap();
addMarkers();

function initiatesMap() {
	map =
		Leaflet
			.map("map", {
				scrollWheelZoom: false
			})
			.setView([43.50, 1.2], 7.4);
	Leaflet.Icon.Default.imagePath = `${location.protocol}//${location.host}/wp-content/themes/rpo/images/vendor/leaflet/dist/`;
	Leaflet.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
		attribution:
			'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
	}).addTo(map);

	Leaflet.control.fullscreen({
		position: 'topleft', // change the position of the button can be topleft, topright, bottomright or bottomleft, default topleft
		title: 'Montrer la carte en plein écran', // change the title of the button, default Full Screen
		titleCancel: 'Sortir du plein écran', // change the title of the button when fullscreen is on, default Exit Full Screen
		content: null, // change the content of the button, can be HTML, default null
		forceSeparateButton: true, // force separate button to detach from zoom buttons, default false
		forcePseudoFullscreen: true, // force use of pseudo full screen even if full screen API is available, default false
		fullscreenElement: false // Dom element to render in full screen, false by default, fallback to map._container
	}).addTo(map);
}


function addMarkers() {
	document.querySelectorAll('.mappable').forEach(function (item) {
		if (item.dataset.latitude && item.dataset.longitude) {
			Leaflet.marker([item.dataset.latitude, item.dataset.longitude])
				.addTo(map)
				.bindPopup(`
						<h3>${item.dataset.title}</h3>
						<p>Lieu : ${item.dataset.location}</p>
						<p>Date : ${item.dataset.date}</p>
						<p><a href="${item.querySelector('a').href}">Afficher l'évènement</a></p>
				`)
			;
		}
	});
}
